import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';

var selectModule = require('../../modules/select')
var zipModule = require('../../modules/zip')
var AjaxFormModule = require('../../modules/ajaxForm');
var LocalizationModule = require('../../modules/localization');
var FloatLabel = require('../../modules/floatLabel');
var phoneModule = require('../../modules/phone');

const MainModule = {
    clickSubmit: 0,
    donationFields: [
        'first_name',
        'last_name',
        'email',
    ],
    throttleTimeout: null,

    selectors: {
        referralPointsValue: '.getReferralPointsAjax',
        referralEarnedCountValue: '.getReferralEarnedCount',

        featuredproduct: '.featuredProductItem',

        orderDataUpdateForm: '#orderDataUpdateForm',
        orderDataUpdateFormFormGroup: '#orderDataUpdateForm .form-group',
        orderDataUpdateFormInput: '#orderDataUpdateForm input',
        orderDataUpdateFormTextarea: '#orderDataUpdateForm textarea',
        forms: {
            subscriptionUpdate: '.subscritioDetailsForm',
            accountSettings: '#settingsEditAjax',
            cancelSubscriptionConfirm: '.cancelSubscriptionReason',
            referralAccount: '.referralAccount',
        },
        errorsContainer: '.profile-errors',
        countries: {
            select2: '.profile-country-select2'
        },
        states: {
            select2: '.profile-state-select2',
            input: '.profile-state-input',
        }
    },

    init() {
        $(document).ready(function () {
            MainModule.initPopups();
            MainModule.initInputs();
            MainModule.initToShowHide();
            MainModule.initFaq();
            MainModule.initMobileSidePanel();
            MainModule.initMainPage();
            MainModule.initTransactionTable();
            MainModule.initAccountSetting();
            MainModule.initDonation();
            MainModule.initSharingPopup();

            MainModule.initReferralPage();

            $('#form-donation [data-check-fields="1"]').on('change', function () {
                MainModule.checkDonationFields();
            })

            MainModule.initOrderDataUpdateForm();

            zipModule.init();
            phoneModule.init();
            MainModule.initStateSelect();
            MainModule.initCountrySelect();
            MainModule.initPhoneValidation();

            MainModule.onFormSubmit();
            MainModule.initSlickSliders();

            FloatLabel.init();

            tippy('[data-tippy-content]', {
                placement: 'bottom',
                theme: 'light',
                arrow: true,
                animation: 'fade',
                interactive: true,
                allowHTML: true,
                appendTo: document.body,
            });

            $('.featured-products-render-mode-js').on('click', function () {
                $('.featured-products-render-mode-js').removeClass('featured-products-render-mode-active');
                $(this).addClass('featured-products-render-mode-active');
                $('#all-rewards-list').removeClass('mode-1').removeClass('mode-2').removeClass('mode-list');
                $('#all-rewards-list').addClass($(this).data('mode'));
            });

            $('.subscription-edit-js').on('click', function (e) {
                let date = new Date();
                date.setTime(date.getTime() + (2*60*1000));
                document.cookie = 'profile-subscription-edit=' + $(this).data('subscription-id') + ';expires=' + date.toUTCString() + ';path=/';
            });
        });
    },

    initReferralPage() {
        $('.tab').on('click', function () {
            let tab = $(this).attr('data-tab');
            $('.tab').removeClass('tab--selected');
            $(`.tab-${tab}`).addClass('tab--selected');
            $('.tab-content').fadeOut(0);
            $(`.tab-content-${tab}`).fadeIn(0);
        });

        jQuery('#referrals').DataTable({
            dom: '<"referrals-table-top"fi>t<"referrals-table-bottom"pl>',
            processing: false,
            pagingType: 'numbers',
            pageLength: 10,
            order: [[0, 'desc']],
            language: {
                search: '',
                searchPlaceholder: 'Search referrals',
                info: '_TOTAL_ Total Referrals',
                infoFiltered: '- filtered from _MAX_ Referrals',
                lengthMenu: '_MENU_ Results per page',
            }
        });
        jQuery('#my-rewards').DataTable({
            dom: '<"my-rewards-table-top"fi>t<"my-rewards-table-bottom"pl>',
            processing: false,
            pagingType: 'numbers',
            pageLength: 10,
            order: [[0, 'desc']],
            language: {
                search: '',
                searchPlaceholder: 'Search rewards',
                info: '_TOTAL_ Total Rewards',
                infoFiltered: '- filtered from _MAX_ Rewards',
                lengthMenu: '_MENU_ Results per page',
            }
        });
    },

    initSlickSliders() {
        $('.slick-slider').slick({
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            lazyLoad: 'ondemand'
        });

        $('.slick-slider-points-banner').slick({
            dots: true,
            infinite: false,
            speed: 300,
            slidesToShow: 1,
            draggable: false,
            autoplay: true,
            appendDots: '#points-banner-slick-dots',
            lazyLoad: 'ondemand'
        });

        $('.rewards-how-earn-more').slick({
            speed: 300,
            slidesToShow: 8,
            arrows: true,
            draggable: true,
            infinite: false,
            nextArrow: '.rewards-arrow-next',
            prevArrow: '.rewards-arrow-prev',
            responsive: [
                {
                    breakpoint: 767,
                    settings: 'unslick'
                },
            ]
        });

        $('.slick-slider-featured').slick({
            speed: 300,
            slidesToShow: 6,
            draggable: true,
            infinite: false,
            arrows: true,
            nextArrow: '.featured-arrow-next',
            prevArrow: '.featured-arrow-prev',
            lazyLoad: 'ondemand',
            responsive: [
                {
                    breakpoint: 767,
                    settings: 'unslick'
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                    }
                }
            ]
        });
    },

    initPhoneValidation() {
        $('[type="tel"]').on('input', function () {
            let val = $(this).val().replace(/[^0-9+,(),-,+]/g, '');
            $(this).val(val)
        });
    },

    initCountrySelect() {
        const selects = $(MainModule.selectors.countries.select2);
        if (selects.length > 0) {
            selects.each(function () {
                let subscriptionId = $(this).attr('data-subscription-id');

                selectModule.init($(this), allCountries).on('select2:select', function (e) {
                    const countryData = e.params.data;
                    if (subscriptionId) {
                        countryData.subscription_id = subscriptionId;
                    }
                    // for subs edit modal
                    $.event.trigger({type: `ProfileCountrySelect_${$(this).attr('data-subscription-id')}:changed`, countryData: countryData});
                    // for referral account
                    $.event.trigger({type: 'countries:changed', countryData: countryData});
                });

                let preSelectCountryId = $(this).val();
                let preSelectCountry = allCountries.find(function(country) {
                    return country.id == preSelectCountryId;
                });

                let countryDataInit = {
                    id: (preSelectCountry)? preSelectCountry.id : null,
                    code: (preSelectCountry)? preSelectCountry.code : null,
                    states_count: (preSelectCountry)? preSelectCountry.states_count : null,
                };
                if (subscriptionId) {
                    countryDataInit.subscription_id = subscriptionId;
                }
                // for subs edit modal
                $.event.trigger({type: `ProfileCountrySelect_${$(this).attr('data-subscription-id')}:init`, countryData: countryDataInit});
                // for referral account
                $.event.trigger({type: 'countries:init', countryData: countryDataInit});
            })
        }
    },

    initStateSelect(countryId, subscriptionId) {
        let selects = [];
        if (subscriptionId) {
            selects = $(MainModule.selectors.states.select2 + '[data-subscription-id="' + subscriptionId + '"]');
        } else {
            selects = $(document).find(MainModule.selectors.states.select2);
        }

        if (selects.length > 0) {
            selects.each(function () {
                let select = $(this);
                let states = [];

                if (!subscriptionId) {
                    countryId = select.data('country-id');
                }

                if (!countryId) {
                    countryId = allCountries[0].id ?? null;
                }

                states = allStates[countryId];
                selectModule.init(select, states)

                $(document).on(`ProfileCountrySelect_${select.attr('data-subscription-id')}:init`, function (e) {
                    if (e.countryData.states_count > 0) {
                        MainModule.toggleElement(select.next(), true);
                        MainModule.toggleElement(select, true);
                        MainModule.toggleElement(select.prev(), false);
                    } else {
                        MainModule.toggleElement(select.next(), false);
                        MainModule.toggleElement(select, false);
                        MainModule.toggleElement(select.prev(), true);
                    }
                })

                $(document).on(`ProfileCountrySelect_${select.attr('data-subscription-id')}:changed`, function (e) {
                    MainModule.onCountryChange(e.countryData, select)
                });
            })
        }
    },

    onCountryChange: function (data, select) {
        const input = select.prev();

        select.trigger('change').val(0);
        $('[name="state_id"], [name="state_name"]').val('');

        MainModule.toggleElement(input, data.states_count === 0)
        MainModule.toggleElement(select, data.states_count > 0)

        if (data.states_count > 0) {
            MainModule.initStateSelect(data.id, data.subscription_id)
        }
        MainModule.toggleElement(select.next(), data.states_count > 0)
    },

    toggleElement: function (el, status) {
        if (status === true) {
            el.css('display', 'block')
            // el.attr('disabled', false) // в модалке редактирования, поле штата не disabled 
        } else {
            el.css('display', 'none')
            // el.attr('disabled', true) // в модалке редактирования, поле штата не disabled 
        }
    },

    initOrderDataUpdateForm() {
        $(MainModule.selectors.orderDataUpdateFormFormGroup).on("click", function () {
            if ($(this).find("input").attr("disabled") === undefined) {
                $(this).find("input").focus();
                $(this).find("textarea").focus();
            }
        });

        const fields = $(`${MainModule.selectors.orderDataUpdateFormInput}, ${MainModule.selectors.orderDataUpdateFormTextarea}`);
        fields.on("focus", function () {
            $(this).parent().find("label").addClass("notEmpty");
        });
        fields.on("blur", MainModule.checkInputs);
    },

    checkDonationFields() {
        if (MainModule.clickSubmit === 0) {
            return false;
        }

        $('.donation-field-error').hide();
        $('.t-input').removeClass('donation_field_error');
        $('.t-select').removeClass('donation_field_error');
        $('.t-checkbox__indicator').removeClass('donation_field_error');
        $('.checkbox-item').find('label').removeClass('donation_field_error');
        $('.donation-form-error').hide();

        MainModule.donationFields.forEach(function (item) {
            let hasError = false;

            if (!$('#' + item).val()) {
                hasError = true;
            } else if ($('#' + item).attr('name') === 'first_name' || $('#' + item).attr('name') === 'last_name') {
                if (!MainModule.validateName($('#' + item).val())) {
                    hasError = true;
                } else if ($('#' + item).val().length > 255) {
                    hasError = true;
                }
            }

            if (hasError) {
                $('#' + item + '-error').show();
                $('#' + item).addClass('donation_field_error');
                $('.donation-form-error').show();
            }
        });

        if (!$('#accept_terms').is(':checked')) {
            $('.checkbox-item').find('label').addClass('donation_field_error');
            $('.donation-form-error').show();
            $('#check-error').show();
        }

        if (!MainModule.isEmail($('#email').val())) {
            $('.donation-form-error').show();
            $('#email-error-format').show();
            $('#email').addClass('donation_field_error');
            $(this).addClass('donation_field_error');
        }
    },

    initDonation() {
        $('body').on('click', '.t-checkbox__indicator', function () {
            jQuery(this).toggleClass('active');
        });

        MainModule.clickSubmit = 0;

        $('#form-donation').on('click', '.bt-orange', function () {
            MainModule.clickSubmit = 1;
            MainModule.checkDonationFields();
            if ($('.donation-form-error').is(':visible')) {
                return false;
            }
        });
    },

    initAccountSetting() {
        $('body').on('click', '.checkbox-item.data-disabled2.disable', function () {
            return false;
        });

        $(document).on('click', '.profile-subscription-edit, .profile-settings-edit', function () {
            let editButton = $(this);
            let form = editButton.closest('form');
            $('.buttons.buttons-edit-active', form).removeClass('profile-buttons-hide');
            $('.buttons.buttons-edit', form).addClass('profile-buttons-hide');
            editButton.addClass('profile-buttons-hide');
            let formInputs = $('input:not([type=hidden]),select,textarea', form);
            formInputs.addClass('profile-input-active').removeClass('profile-input-disabled').prop('disabled', false);
        });

        $(document).on('click', '.profile-subscription-cancel, .profile-settings-cancel', function () {
            let closeButton = $(this);
            let form = closeButton.closest('form');
            $('.buttons.buttons-edit-active', form).addClass('profile-buttons-hide');
            $('.buttons.buttons-edit', form).removeClass('profile-buttons-hide');
            $('.profile-subscription-edit, .profile-settings-edit', form).removeClass('profile-buttons-hide');
            let formInputs = $('input:not([type=hidden]),select,textarea', form);
            formInputs.removeClass('profile-input-active').addClass('profile-input-disabled').prop('disabled', true);

            if (
                $(MainModule.selectors.countries.select2).length > 0 &&
                $(MainModule.selectors.countries.select2).is(':visible')
            ) {
                let oldCountryId = $(MainModule.selectors.countries.select2).data('old-value');
                let oldCountry = allCountries.find(function(country) {
                    return country.id == oldCountryId;
                });
                $(MainModule.selectors.countries.select2).select2('trigger', 'select', {data: oldCountry});
            }

            if (
                $(MainModule.selectors.states.select2).length > 0 &&
                $(MainModule.selectors.states.select2).is(':visible')
            ) {
                let oldState = $(MainModule.selectors.states.select2).data('old-value');
                $('select' + MainModule.selectors.states.select2).select2('trigger', 'select', {
                    data: { id: oldState }
                });
            }

            $('input,textarea', form).each(function (i, input) {
                let inputObject = $(input);
                if (typeof inputObject.data('old-value') !== 'undefined') {
                    inputObject.val(inputObject.data('old-value'));
                }
            })
        });
    },

    initMobileSidePanel() {
        $(document).toShowHide({
            button: '.bt-menu',
            box: '.sidebar-mobile',
            effect: 'fade',
            button_close: '.icon-close',
            onShow: function (el) {
                $('#overlay').addClass('active');
            },
            onHide: function (el) {
                $('#overlay').removeClass('active');
            }
        });
    },

    initTransactionTable() {
        $('.history-block-table .history-block-row').toShowHide({
            button: '.history-block-row-head',
            box: '.history-block-row-content-wrapper',
            close_only_button: true,
            onBefore: function (el) {
                el.find('.history-block-row-head').addClass('active');
            },
            onAfter: function (el) {
                el.find('.history-block-row-head').removeClass('active');
            }
        });
    },

    initMainPage() {
        $(document).on('click', '.js-bt-all-subs', function () {
            $('.subs-box:not(:first)', $(this).parents().find('#profile-main-subscriptions')).toggleClass('hidden');
            $('.subheader-disabled', $(this).parents().find('#profile-main-subscriptions')).toggleClass('hidden');
            $(this).toggleClass('active');
        })
    },

    initPopups() {
        $('.open-popup-link').magnificPopup({
            type: 'inline',
            midClick: true
        });

        $('.featured-product-open').magnificPopup({
            type: 'ajax',
            showCloseBtn: false,
            closeOnBgClick: false,
            fixedContentPos: true,
            removalDelay: 300,
            mainClass: 'mfp-fade pr-wrapper'
        });

        $('.open-transaction-history').magnificPopup({
            type: 'ajax',
            showCloseBtn: false,
            closeOnBgClick: false,
            fixedContentPos: true,
            removalDelay: 300,
            mainClass: 'mfp-fade trh-wraper'
        });

        if ($('.referral-level').length > 0) {
            $('.referral-level').magnificPopup({
                type: 'ajax',
                showCloseBtn: false,
                closeOnBgClick: false,
                fixedContentPos: true,
                removalDelay: 300,
                mainClass: 'mfp-fade rln-wraper',
                callbacks: {
                    ajaxContentAdded: function() {
                        $('.rln-close').on('click', function () {
                            $('.tab-3').trigger('click');
                        });
                    }
                }
            });
            $('.referral-level').magnificPopup('open', 1);
        }

        $('[data-mfp-src="#templates-popup"]').magnificPopup({
            type: 'inline',
            fixedContentPos: true,
            removalDelay: 300,
            mainClass: 'mfp-fade rln-wraper',
        });
        $('[data-mfp-src="#templates-images-popup"]').magnificPopup({
            type: 'inline',
            fixedContentPos: true,
            removalDelay: 300,
            mainClass: 'mfp-fade rln-wraper',
        });

        $('.referral-level-item').toShowHide({
            button: '.referral-level-head',
            box: '.referral-level-text',
            onBefore: function (el) {
                el.addClass('active');
            },
            onAfter: function (el) {
                el.removeClass('active');
            }
        });

        $('.open-referral-faq').magnificPopup({
            type: 'ajax',
            showCloseBtn: false,
            closeOnBgClick: false,
            fixedContentPos: true,
            removalDelay: 300,
            mainClass: 'mfp-fade rpf-wraper',
            callbacks: {
                ajaxContentAdded: function() {
                    $('.rpf-faq-item').toShowHide({
                        button: '.rpf-faq-head',
                        box: '.rpf-faq-text',
                        onBefore: function (el) {
                            el.addClass('active');
                        },
                        onAfter: function (el) {
                            el.removeClass('active');
                        }
                    });
                }
            }
        });

        $('.open-subscription-edit').magnificPopup({
            type: 'ajax',
            showCloseBtn: false,
            closeOnBgClick: false,
            fixedContentPos: true,
            removalDelay: 300,
            mainClass: 'mfp-fade es-wraper',
            callbacks: {
                ajaxContentAdded: function() {
                    MainModule.initStateSelect();
                    MainModule.initCountrySelect();
                    MainModule.initPhoneValidation();

                    phoneModule.init();
                    zipModule.init();

                    if ($('select.cancel-reason-select2', this.content).length > 0) {
                        selectModule.init($('select.cancel-reason-select2', this.content))
                        $('select.cancel-reason-select2').on('select2:select', function (e) {
                            if (e.params.data.id == 'other') {
                                $('.other-cancel-reason', this.content).show();
                            } else {
                                $('.other-cancel-reason', this.content).hide();
                            }
                        });
                    }

                    document.cookie = 'profile-subscription-edit=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;';

                    $('.open-subscription-modal').magnificPopup({
                        type: 'ajax',
                        showCloseBtn: false,
                        closeOnBgClick: false,
                        fixedContentPos: true,
                        removalDelay: 300,
                        mainClass: 'mfp-fade cs-wraper',
                    });
                }
            }
        });
        $('.open-subscription-edit').prop('disable', false);
        $('.open-subscription-edit').removeClass('disabled');

        let editSubscription = document.cookie.match(new RegExp('(^| )profile-subscription-edit=([^;]+)'));
        editSubscription = (editSubscription)? editSubscription[2]: null;

        if (editSubscription) {
            let editButton = $('.open-subscription-edit[data-subscription-id="' + editSubscription + '"]').first();
            if(editButton.length > 0) {
                $('.open-subscription-edit').magnificPopup('open', editButton.data('popup-key'));
            }
        }

        $(document).on('click', '.m-close-js', function () {
            $.magnificPopup.close();
        });
    },

    initInputs() {
        $('input[placeholder], textarea[placeholder]').placeholder();

        $('input, textarea').focus(function () {
            $(this).data('placeholder', $(this).attr('placeholder'))
            $(this).attr('placeholder', '');
        });
        $('input, textarea').blur(function () {
            $(this).attr('placeholder', $(this).data('placeholder'));
        });

        $('input.mask-phone').mask('+7 (999) 999-99-99', {autoclear: true}).on('click', function () {
            $(this)[0].selectionStart = 2;
            $(this).focus();
        });
    },

    initToShowHide() {
        $('.faq-item').toShowHide({
            button: '.head',
            box: '.text',
            onBefore: function (el) {
                el.addClass('active');
            },
            onAfter: function (el) {
                el.removeClass('active');
            }
        });

        $('.open-incentive-js').toShowHide({
            button: '.incentive-header',
            box: '.incentive-description-wrapper',
            onBefore: function (el) {
                el.addClass('active');
            },
            onAfter: function (el) {
                el.removeClass('active');
            }
        });
    },

    initFaq() {
        $('.tab-block').hide().removeClass('separate');

        $('.tab-block[data-id=' + $('.tabs a.active').data('id') + ']').show().not(":last").addClass('separate');
        $('.tabs a').on('click', function () {
            $('.tabs a').removeClass('active');
            $(this).addClass('active');

            $('.tab-block').hide().removeClass('separate');
            $('.tab-block[data-id=' + $(this).data('id') + ']').show().not(":last").addClass('separate');

            return false;
        });
    },

    isEmail(email) {
        const regex = /^[\+\-\p{L}\p{M}\p{N}_]([\p{L}\p{M}\p{N}!#$%&‘*+\-\/=?^_`{|}~.]*)@(?=.{4,256}$)(([\p{L}\p{N}\p{M}]+)(([\-_]*[\p{L}\p{M}\p{N}])*)[.])+[\p{L}\p{M}]{2,22}$/u;
        return regex.test(email);
    },

    checkInputs() {
        $("#orderDataUpdateForm input, #orderDataUpdateForm textarea").each(function () {
            if ($(this).val() !== undefined && $(this).val() !== "") {
                $(this).parent().find("label").addClass("notEmpty");
            } else {
                $(this).parent().find("label").removeClass("notEmpty");
            }
        })
    },

    onFormSubmit: function () {
        $(document).on('submit', Object.values(MainModule.selectors.forms).join(','), function (e) {
            e.preventDefault();
            let form = $(this);

            if ($('[name="state_id"]', form).is(':hidden')) {
                $('[name="state_id"]', form).prop('disable', true);
            }
            if ($('[name="state_name"]', form).is(':hidden')) {
                $('[name="state_name"]', form).prop('disable', true);
            }

            $('button', form).attr('disabled', true).addClass('disabled');

            // if ($('.phoneInput').length > 0) {
            //     $('.phoneInput').val($('.phoneInput').val().trim());
            // }

            let validationRules;
            if (form.is(MainModule.selectors.forms.subscriptionUpdate)) {
                validationRules = AjaxFormModule.validationRules.profile.subscription;
            } else if (form.is(MainModule.selectors.forms.accountSettings)) {
                validationRules = AjaxFormModule.validationRules.profile.settings;
            } else if (form.is(MainModule.selectors.forms.cancelSubscriptionConfirm)) {
                validationRules = AjaxFormModule.validationRules.profile.cancel_subscription;
            } else if (form.is(MainModule.selectors.forms.referralAccount)) {
                validationRules = AjaxFormModule.validationRules.profile.referral_account;
            }

            let formValidator = AjaxFormModule.validate(
                form,
                validationRules,
                LocalizationModule.getTranslationsByKey('form_contact')
            );

            if (form.valid()) {
                AjaxFormModule.submit(form, function (response) {
                    if (response.popup_message !== undefined) {
                        toastr[response.popup_message.type](response.popup_message.message);
                    }
                    if (response.url !== undefined) {
                        window.location = response.url;
                    }
                    $('button', form).attr('disabled', false).removeClass('disabled');
                }, function (response) {
                    $('button', form).attr('disabled', false).removeClass('disabled');
                }, $(MainModule.selectors.errorsContainer), false);
            } else {
                $('button', form).attr('disabled', false).removeClass('disabled');
            }
        })
    },
    initSharingPopup: function() {
        // Tabs
        $('.rln-popup-sharing').each(function () {
            const popup = $(this);
            popup.find('.popup-tab').on('click', function () {
                const tabId = $(this).data('tab');
                popup.find('.popup-tab, .popup-tab-content').removeClass('active');
                $(this).addClass('active');
                popup.find('.popup-tab-content-' + tabId).addClass('active');
                popup
                    .removeClass('active-1 active-2')
                    .addClass('active-' + tabId);
            });
        });

        // Gallery
        $('.rln-gallery--item').on('click', function () {
            const parent = $(this).closest('.popup-tab-content');
            parent.find('.rln-gallery--item').removeClass('active');
            $(this).addClass('active');
            const url = $(this).find('img').attr('src');
            parent.find('.rln-gallery-main img').attr('src', url);
        });
        $('.rln-gallery--item-download').on('click', function () {
            const url = $(this).closest('.rln-gallery-main').find('img').attr('src');
            if (!url) return;
            $('<a>').attr({ href: url, download: url.split('/').pop() }).appendTo('body')[0].click();
            $('a[download]').last().remove();
        });
        $(window).on('load', function () {
            setTimeout(() => {
                $('#templates-images-popup img').attr('loading', 'eager')
            }, 2000);
        });

        // Copying
        $('.rln-template--copy').on('click', function () {
            const $btn = $(this);
            const text = $btn
                .closest('.rln-template')
                .find('.rln-template--content')
                .html()
                .replace(/<br\s*\/?>/gi, '\n')
                .trim();

            const showCopied = () => {
                $btn.addClass('active');
                setTimeout(() => $btn.removeClass('active'), 3000);
            };

            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(text).then(showCopied).catch(() => fallbackCopy(text, showCopied));
            } else {
                fallbackCopy(text, showCopied);
            }

            function fallbackCopy(text, callback) {
                const $temp = $('<textarea>').val(text).appendTo('body').select();
                document.execCommand('copy');
                $temp.remove();
                callback();
            }
        });
    },
}

MainModule.init();
